module.exports = __webpack_public_path__ + "img/hot-img4.1a6450dc.png";